export default "__VITE_ASSET__Dpe9Xq9K__"